module.exports = "/images/Icon-2.svg?8fa6ff81babba8b46d942d85bca99620";